
import Vue  from 'vue'
import { ProductCategory } from '@/model/productCategory'

import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { IMAGE_VARIANT } from '@/common/const'
import scrollTo from '@/common/animatedScrollTo'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    },
    isFooter: {
      type: Boolean,
      default: true
    }
   },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    IMAGE_VARIANT() {
      return IMAGE_VARIANT.CATEGORY_ICON_THUMBNAIL
    }
  },
  methods: {
    scrollToParentCategory(categoryId: number, categoryUrl: string){
      if (this.isFooter) {
        window.location.href = categoryUrl
      }
      else {
        const target = document.getElementById(categoryId.toString())
          if (target) {
            const targetOffset = target.offsetTop - 24
            scrollTo(targetOffset, 300)
          }
      }
    }
  }
})
